<template>    
    <div class="py-4 container-fluid">
        <div class="row">
            <div class="col-lg-9">                  
                <div class="row mb-5">                    
                    <div class="col-lg-12 mt-lg-0 mt-4">
                        <studebook-section-detail />                        
                    </div>
                </div>
            </div>
        </div>
        <div class="row"></div>
    </div>        
</template>

<script>
import StudebookSectionDetail from "./components/StudebookSectionDetail.vue"

export default {
    name: 'StudebookStatus_edit_page',
    components: {        
        StudebookSectionDetail
    },
    data() {
        return {
            Id: '',
            studebooksections: [],
            gets: []
        }
    },
    async mounted() {
        this.id = this.$route.params.id;   
        console.log('Route ID:', this.id);   
    },
}
</script>